import { useEffect, useState } from "react";
import axios from 'axios';
import './Header.css';

function Header(props) {
    const [url] = useState(window.location.search);
    const [data, setData] = useState({});
    const [title, setTitle] = useState('');

    useEffect(() => {
        async function fetchData() {
            const result = await axios(
                './data/' + url.replace('?data=', '') + '_title.json',
            );
            setData(result.data);
        }
        fetchData();
    }, [url, props.lang]);

    useEffect(() => {
        switch(props.lang.substr(0, 2)){
            case 'jp':
                setTitle(data.jp);
            break;
            case 'en':
                setTitle(data.en);
            break;
            default:
            break;
        }
    },[props.lang, data]);

    return (
        <header>{ title }</header>
    );
};

export default Header;